export const constant = ['tmrLimitZeroWorkaround', 2000]
